import { createContext, useContext, useState, useCallback } from "react";
import { toast } from "sonner";

const LanguageContext = createContext({ lang: "EN", setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState("EN");

  const setLang = useCallback((next) => {
    if (next === "BM") {
      toast.info("Versi Bahasa Malaysia akan datang.", {
        description: "Bahasa Malaysia translation arriving in a future release.",
      });
      return;
    }
    setLangState(next);
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
